
import "./style.css";

import { Suspense} from 'react';
import useResize from "@app/hook/useResize";
import loadable from '@loadable/component'
import { userDatas } from "@app/hoc/cache";

interface ResizableFrameProps {
  src: string;
  title: string;
  path: string;
  cid: string;
  status: number;
  nextCard: any;
  iframeStyles?: Record<string, unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const Form = ({
  src,
  title,
  data,
  path,
  cid,
  status,
  nextCard,
  iframeStyles = {},
  ...rest
}: ResizableFrameProps): JSX.Element => {

    //const { width : cWidth, height: cHeight } = useResize();
    const { width : cWidth, height: cHeight } = userDatas();

    //src = 'UserLogin'
    src = src.replace(/..\/Form\//i, '')

    if( src === 'CNTBase') src = 'BaseCNT'; 
    else if( src !== "YMPLogin" && src !== "YMLogin" 
      && src !== "YMUserRegist" && src !== "YMTargetRegist" 
      && src !== "YMGroupRegist" && src !== "YMExamineeRegist" 
      && src !== "YMTargetList" && src !== "YMTaskList" && src !== "YMExamineeList" 
      && src !== "YMTask" && src !== "YMTaskGuide" && src !== "YMReport"
      && src !== "YMSlideCard"
      && src.indexOf("YM") === 0 ) src = 'YMBase'; 

    const ExForm = loadable(() => import(`../Form/${src}`)); //${src}`)); 
    return (
      <Suspense fallback={<div>Loading...</div>}>              
        <ExForm title={title} data={data} nextCard={(cIdx:number)=>nextCard(cIdx)}/>
      </Suspense>
    )
};
export default Form;
